import { Clipart } from 'ff-canvas';
import { UndoViewbox } from '@gift/common/helpers/transformParameters';

export function createBackgroundPaintable(
    sceneWidth: number, sceneHeight: number,
    undoViewbox: UndoViewbox,
    assetUrl: string
): Clipart {

    const width = sceneWidth * undoViewbox.scaling;
    const height = sceneHeight * undoViewbox.scaling;

    return {

        id: 'background',
        type: 'clipart',

        x: -0.5 * width + undoViewbox.offsetX,
        y: -0.5 * height + undoViewbox.offsetY,
        width: width,
        height: height,
        zIndex: -99999,
        angle: 0,

        flipX: false,
        flipY: false,

        scaleX: 1,
        scaleY: 1,
        alpha: 1,

        url: assetUrl,
        shadow: false,
        shadowBlur: 0,
        shadowColor: '#000',
        shadowOffsetX: 0,
        shadowOffsetY: 0,

        stroke: false,
        strokeSize: 0,
        strokeStyle: 'red',

        custom: {
            watch: [],
            values: {}
        },

        round: true
    };
}